module.exports = __webpack_public_path__ + "media/04 be known for.41aeb7d3.mp3";